import { render, staticRenderFns } from "./add-flight.vue?vue&type=template&id=05cbc995&"
import script from "./add-flight.vue?vue&type=script&lang=js&"
export * from "./add-flight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/opt/buildhome/repo/components/global/Button.vue').default,ManualFlight: require('/opt/buildhome/repo/components/manual-flight/index.vue').default,Modal: require('/opt/buildhome/repo/components/global/Modal/index.vue').default,SimulatorFlight: require('/opt/buildhome/repo/components/simulator-flight/index.vue').default})
